import React, { Suspense, useEffect, useState } from 'react';
import './App.css';

import MainRoute from './routes/MainRoute';
import { BrowserRouter } from 'react-router-dom';
import Loading from './components/form/Loading';

import { useSelector } from 'react-redux';
import { http } from './utils/http';
import { notification } from 'antd';
import { separateErrorMessages } from './utils/globalErrorUtils';
import UnauthorizedErrorModal from './components/Modals/UnauthorizedErrorModal';
import Cookies from 'js-cookie';

function App() {
  const { isModel, modelTitle } = useSelector((state) => state.Loading);
  const [api, contextHolder] = notification.useNotification({ stack: 4 });
  const [showUnauthorizedErrorModal, setShowUnauthorizedErrorModal] = useState(false);

  useEffect(() => {
    http.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error?.response?.status === 401 && Cookies.get('jwtToken') !== undefined) {
          // this handles users whose token might have expired and the server returns error 401
          // we will push them to the login page, and clean up the cookies
          setShowUnauthorizedErrorModal(true);
        } else {
          const errorsGenerated = separateErrorMessages(error?.response?.data?.message);

          errorsGenerated?.forEach((element) => {
            api.error({
              message: 'Error ' + error?.response?.data?.statusCode,
              description: element,
              placement: 'bottomRight',
            });
          });
        }
      }
    );
  }, []);

  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div>
            <Loading />
          </div>
        }
      >
        {showUnauthorizedErrorModal ? (
          <UnauthorizedErrorModal
            showUnauthorizedErrorModal={showUnauthorizedErrorModal}
            setShowUnauthorizedErrorModal={setShowUnauthorizedErrorModal}
          />
        ) : (
          isModel && <Loading>{modelTitle || ' '}</Loading>
        )}
        {contextHolder}

        <MainRoute />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
